import { PropertyOpportunityTypeEnum } from "store/properties/types";

export const typesCases = {
  'lp-investments': PropertyOpportunityTypeEnum.LP_INVESTMENTS,
  'property-investments': PropertyOpportunityTypeEnum.PROPERTY_INVESTMENTS,
}
